// eslint-disable-next-line
export default {
  id: 'camarao_na_moranga_desconstruido',
  type: 'savoury',
  title: 'Camarao na moranga desconstruido',
  ingredients: [
    '250g camarão',
    '1 limão',
    '1 cebola roxa',
    '2 tomates',
    '? girimum',
    '? aspargos',
    '? creme de leite ou leite de coco',
  ],
  parts: [
    {
      title: 'Pre-preparo',
      methodOfPreparation: [
        'Cozinhe o girimum. Quando cozinhado, amasse ele para virar uma pasta',
        'Tempere os camarões com sal e limão e os frite',
      ],
    },
    {
      title: 'Finalização',
      methodOfPreparation: [
        'Frite a cebola até ela começar a ficar dourada',
        'Coloque o tomate, aspargos e a pasta de girimum',
        'Coloque os camarões',
        'Coloque o creme de leite ou leite de coco',
        'Misture tudo muito bem',
        'Ajuste sal e limão',
      ],
    },
  ],
};
